(function ($) {
  function ConvertCurrencyToString(currency){
    return Shopify.formatMoney(currency * 100, window.theme.moneyFormat);
  }

  function calculatDiscount(disPer, price) {
    var discount = parseInt(disPer)
    var disPrice = (100 + discount) * price / 100;
    return ConvertCurrencyToString(disPrice);
  }

  function renderItems(item, productIndex) {
    let hasVariants = '';
    let selectedVariant = item?.variants[0];

    if(!selectedVariant || selectedVariant?.price === 0) return;

    let productFormId = "product_form_" + item.id + "_" + productIndex;
    let productWrapperId = "product_wrapper_" + item.id + "_" + productIndex;
    let urlImage = typeof item.image === 'object' && item.image !== null ? (item.image.hasOwnProperty('src') ? item.image.src : '') : '';
    let productName = item.title.length > 50 ? item.title.substring(0, 50) + '...' : item.title;
    var hideOldPrice = "";

    // AA tracking value
    var priceValue = selectedVariant.compare_at_price;
    var discountPriceValue = selectedVariant.price;
    var productTags = item.tags;
    var modelValue = '';
    var superModelValue = '';
    var categoryValue = '';
    if (productTags) {
      productTags = productTags.split(", ");
      productTags.forEach(function (value) {
        if (value.includes('__model:')) {
          modelValue = value.replace('__model:','');
        };
        if (value.includes('__superModel:')) {
          superModelValue = value.replace('__superModel:','');
        };
        if (value.includes('_sixdcode:')) {
          categoryValue = value.replace('_sixdcode:','');
        };
      });
    }

    if (selectedVariant?.compare_at_price <= selectedVariant?.price) {
      hideOldPrice = "display:none;";
    }

    if (item.variants.length) {
      hasVariants = 'has-variants';
    }
    
    var product = "<div class='grid__cell pwp-product 1/2--handheld-and-up 1/4--desk'>" +
        "    <div class='product-item product-"+ item.id + "_" + productIndex + " product-item--push'" +
        "         data-allow-selecting-sold-out-variants='true'>" +
        "        <figure class='product-item__image-container'>" +
        "            <div class='product-item__image-wrapper'>" +
        "                <a href='/products/"+ item.handle +"'>" +
        "                    <div class='aspect-ratio'>" +
        "                        <img class='product-item__image lazyload image--fade-in'" +
        "                             alt='" + item.title + "'" +
        "                             src='" + urlImage + "'>" +
        "                    </div>" +
        "                </a>" +
        "            </div>" +
        "        </figure>" +
        "        <div class='product-item__info'>" +
        "            <h3 class='product-item__title'>" +
        "                <a href='/products/"+ item.handle +"' class='link'>" + productName + "</a>" +
        "            </h3>" +
        "            <div class='bv-ratings-block'>" +
        "                <div data-bv-show='inline_rating' data-bv-product-id='"+ item.handle +"'" +
        "                     data-bv-redirect-url='/products/"+ item.handle +"' data-bv-seo='false'></div>" +
        "            </div>" +
        "            <div class='product-content-bottom' id='"+productWrapperId+"'>" +
        "                <span class='product-item__price product-item__price--new' data-money-convertible=''>" +
                            ConvertCurrencyToString(selectedVariant?.price) + 
        "                </span>" +
        "                <div class='tooltip-wrapper'>" +
        "                    <span class='price-tooltip'>1</span>" +
        "                    <div class='tooltip-content'>" +
        "                        <p>1. Prices indicated refer to Suggested Retail Price which includes VAT and" +
        "                            may change from time to time without prior notice.</p>" +
        "                    </div>" +
        "                </div>" +
        "                <span class='product-item__price product-item__price--old' data-money-convertible='' style='" + hideOldPrice + "'> " +
                            ConvertCurrencyToString(selectedVariant?.compare_at_price) +
        "                </span>" +
        
        "                <div id='" + productFormId + "'" + "class='product__form'>" +
        "                    <input type='hidden' name='model_"+ item.id +"' value='"+ modelValue +"'>" +
        "                    <input type='hidden' name='superModel_"+ item.id +"' value='"+ superModelValue +"'>" +
        "                    <input type='hidden' name='sixdcode_"+ item.id +"' value='"+ categoryValue +"'>" +
        "                    <input type='hidden' name='quantity' value='1'>" +
        "                    <input type='hidden' name='id' value='" + selectedVariant?.id + "'>" +
        "                    <input type='hidden' name='productId' value='" + item.id + "'>" +
        "                    <input type='hidden' name='sku' value='" + selectedVariant.sku + "'>" +
        "                    <input type='hidden' name='single-compare-at-price' value='" + priceValue + "'>" +
        "                    <input type='hidden' name='single-price' value='" + discountPriceValue + "'>" +
        "                    <div class='product-item__add-to-cart button-wrapper "+ hasVariants +"'>" +
        "                        <button data-id='" + productFormId + "' type='button' class='product__add-to-cart add-cart-pwp button button--primary button--orange'> Add to cart </button>" +                    
        "                    </div>" +
        "                </div>" +
        "        		 <div style='font-size: 12px; color: #2f353d; text-align: center; margin-top: 5px;'>" +
        "           		<p style='font-size: 13px; margin-bottom: 0px;'>" +
        "			    		Discount Code: " +
        "           		</p>" +
        "                	<span> " +
        "						<button style='border: none; font-size: 14px; background-color: transparent; font-weight: bold; color: #2f353d' class='copy-to-clipboard'  title='Copied'>" +
        "                    		<svg class='icon icon-wishlist'>" +
        "                        		<use xlink:href='#icon-copy'></use>" +
        "                    		</svg>" +
        "            			<span>" + item.discount_code + "</span>" +
        "            			<input style='display: none;' type='text' name='discount-code' value='" +item.discount_code + "'/>" +
        "                		</button>" +
        "                	</span>" +
        "        		 </div>" +
        "                <div class='product-discount_text'> " +
                            item.discount_text +
                            (item.discount_value !== "-100.0" ?  "<span class='product-discount_price' data-discount-value='" + item.discount_value + "'> (" + calculatDiscount(item.discount_value, selectedVariant?.price) + ")</span>" : "" ) +
        "                </div>" +
        "            </div>" +
        "        </div>" +
        "        <div class='product-item__see-more button-wrapper '>" +
        "            <a href='"+ item.handle +"' class='button button--primary'>View Detail</a>" +
        "        </div>" +
        "    </div>" +
        "</div>";

    var pageWrapper = document.getElementById("list_product_pwp");

    if (pageWrapper.innerHTML.length == 199) {
      pageWrapper.childNodes[1].remove();
    }
    
    pageWrapper.innerHTML = pageWrapper.innerHTML + product;
    
    if (item.variants.length && item.options.length > 0) {
      var color_label = 'color,colour,couleur,colore,farbe,색,色,färg,farve';
      var colors = item.options.find(x => color_label.indexOf(x.name.trim().toLowerCase()) !== -1);

      let colorSwatchIndex = item.id + "-color-swatch-" + productIndex + "-";
      
      let mainVariants = 
          " <div class='product__variants '>\n" +
          "  <div class='form__control  variant-colour' style='margin-bottom: 0;'>\n" +
          "    <ul class='product__available-colors list--unstyled' data-selector-type='color'>\n" +
          "      [[Color-Options]]</ul>\n" +
          "   </div>\n" +
          " </div>\n";

      var options = "";

      if(colors) {
        colors.values.forEach((color, index) => {
          var variantItem = item.variants.find(x => x.option1 == color)
          
          if (variantItem != null) {
            var imageItem = item.images.find(x => jQuery.inArray(variantItem.id, x.variant_ids) > -1);
            
            isSelected = selectedVariant?.id === variantItem.id;
  
            var checked = "";
            var colorWhite = "";
  
            if (isSelected) {
              checked = "checked='checked'";
  
              $('#' + productFormId + ' .product-item__add-to-cart button').html("Add To Cart <span title='"+ color +"'>("+ color +")</span>");
            }
  
            if (color.toLowerCase() == 'white' || color.toLowerCase() == 'cream' ){
              colorWhite = "color-swatch--white";
            }

            var option = "<li class='product__color " + variantItem.id + "_" + productIndex + "_" + index + " ' title='" + color + "' data-variant-id='" + variantItem.id + "' data-point='" + index + "' data-new-price='" + variantItem.price + "' data-old-price='" + variantItem.compare_at_price + "' data-image-src='" + imageItem?.src + "'>\n" +
                "             <input data-option-index='option1' data-main-button='" + productFormId + "' id='" + colorSwatchIndex + index + "' class='single-option-selector' name='single-option-selector-pwp-" + productIndex + "' type='radio' " + checked + " value='color'>\n" +
                "             <label for='" + colorSwatchIndex + index + "' tabindex='0' class='color-swatch " + colorWhite + "' style='background-color: " + color.trim().toLowerCase() + "'>\n" +
                "             	<span>Color</span>\n" +
                "             </label>\n" +
                "             <svg class='icon icon-tick'>\n" +
                "                <use xlink:href='#icon-tick'></use>\n" +
                "             </svg>\n" +
                "         </li>\n";
  
            options = options + option;
          }
        });
      }
      
      if (options === "") {
        options = "<span class='no-color-swatch'>&nbsp;</span>";
      }

      mainVariants = mainVariants.replace("[[Color-Options]]", options);

      var variantWrapper = $(".product-" + item.id + "_" + productIndex + " .product-item__info");
      
      variantWrapper.prepend(mainVariants);
    }
    else {
      $(".product-" + item.id + "_" + productIndex + " .product-item__info").prepend("<span class='no-color-swatch'>&nbsp;</span>");
    }
  }

  function loadProductPWP(collectionsId, productId, variantId){

    var currentDate = (new Date()).toUTCString();

    http.get('discounts/GetPriceRulesPWP?CollectionIds=' + collectionsId + '&ProductId=' + productId + '&VariantId=' + variantId + '&Date=' + encodeURI(currentDate))
      .done(function (res) {       
        if(res.length > 0) {
          document.getElementById("shopify-section-pwp-products").style.display = 'block';

          res.forEach(renderItems);

          var wrapperContainer = $("#list_product_pwp");

          // trigger change to load the selected image
          wrapperContainer.find('.single-option-selector:checked').trigger('change');

          if (wrapperContainer.hasClass("slick-initialized")) {
              wrapperContainer.slick('unslick');
          }

          if(!wrapperContainer.hasClass('slick-initialized')) {
            wrapperContainer.slick({
                infinite: false,
                dots: false,
                arrows: true,
                adaptiveHeight: false,
                mobileFirst: true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                pauseOnHover: false,
                accessibility: false,
                useCSS: true,
                prevArrow: '<button title="Prev" class="fs-slideshow__nav-button fs-slideshow__nav-prev slick-prev"><span>Prev</span><svg class="icon icon-arrow-left"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use></svg></button>',
                nextArrow: '<button title="Next" class="fs-slideshow__nav-button fs-slideshow__nav-next slick-next"><span>Next</span><svg class="icon icon-arrow-right"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use></svg></button>',
                responsive: [
                  {
                    breakpoint: 560,
                    settings: {
                      slidesToShow: 2
                    }
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 3
                    }
                  },
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 4
                    }
                  }
                ]
            })
          }
        }
        else {
          document.getElementById("shopify-section-pwp-products").style.display = 'none';
        }
      });
  
  }

  $(document).ready(function (e) {
    let component = $('#shopify-section-pwp-products');

    if (component.length != 0){
      var collectionsId = $(component).data('collectionsId');
      var productId = $(component).data('productid');
      var variantId = $(component).data('variantid');

      if ($('#product-detail-' + productId + ' button.product__add-to-cart:disabled').length == 0)
      loadProductPWP(collectionsId, productId, variantId);
    } 
  });

  $('#pwp_products_container').on('click', '.add-cart-pwp', function (e) { 
    var self = $(this);

    self.attr('disabled', 'disabled').addClass('button--loading');

    var elementId = self.data('id');
    var element = $('#' + elementId);
    var id = element.children('input[name="id"]').val();
    var productId = element.children('input[name="productId"]').val();

    let formData = {
      'items': [{
        'id': id,
        'quantity': 1
      }]
    };

    // Adobe analytics Event Addtocart
    var skuValue = element.children('input[name="sku"]').val();
    var modelValue = element.children('input[name^="model_"]').val();
    var supperModelValue = element.children('input[name^="superModel_"]').val();
    var categoryValue = element.children('input[name^="sixdcode_"]').val();
    var priceValue = element.children('input[name="single-compare-at-price"]').val();
    var discountPriceValue = element.children('input[name="single-price"]').val();
    var quantityValue = element.children('input[name^="quantity"]').val();
    if (priceValue != 'null') {
      priceValue = priceValue;
    } else {
      priceValue = discountPriceValue;
    }
    var discountValue = Math.floor((priceValue - discountPriceValue) * 100 / priceValue);
            
    const detailItems = {
      sku: [skuValue],
      model: [modelValue],
      superModel: [supperModelValue],
      quantity: [quantityValue],
      category: [categoryValue],
      price: [priceValue],
      discount: [discountValue],
      discountprice: [discountPriceValue],
      loyaltyPoints: 0
    };
    
    var event = new CustomEvent("addToCart", {
      detail: detailItems 
    });
    
    document.dispatchEvent(event);
    console.log('addtocart', detailItems); 

    fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
    })
    .then(cart => {
      self.removeAttr('disabled').removeClass('button--loading');  

      if (cart.status != 422) {
        $(document).trigger('theme:cart:updated', [cart, true, true]);
      }
      else {
        var addToCartVariant = self.find("> span").text();
        self.text(window.languages.sold_out_message);
        self.attr("old-text", addToCartVariant);

        setTimeout(function() {
          self.text(window.languages.productFormAddToCart);
          var attr = self.attr('old-text');

          if (typeof attr !== typeof undefined && attr !== "") {
            self.append("<span>" + attr + "</span>");
          }
        }, 2500);
      }
      // return cart.json();
    })
    .catch((error) => {
      self.removeAttr('disabled').removeClass('button--loading');
      console.error('Error:', error);
    });

  });

  $('#pwp_products_container').on('change', '.single-option-selector', function (e) {
    var formId = $(this).data('main-button');
    var mainOption = $(this).parent();
    var variantId = mainOption.data('variant-id');
    var newPrice = mainOption.data('new-price');
    var oldPrice = mainOption.data('old-price');
    var imageSrc = mainOption.data('image-src');
    var strNewPrice = ConvertCurrencyToString(newPrice);
    var colorText = mainOption.attr('title');
    var productId = $(this).attr('id').split('-')[0];
    var productIndex = $(this).attr('id').split('-')[3];

    var discountPriceElm = $(this).closest('.pwp-product').find('[data-discount-value]');
    
    var element = $('#' + formId);

    element.children('input[name="id"]').val(variantId);
    
    var parentElement = element.parent();
    parentElement.children('.product-item__price--new').text(strNewPrice);
    
    if (oldPrice > newPrice) {
      var strOldPrice = ConvertCurrencyToString(oldPrice);

      parentElement.children('.product-item__price--old').text(strOldPrice);
      parentElement.children('.product-item__price--old').css('display', 'inline-block');
    }
    else {
      parentElement.children('.product-item__price--old').css('display', 'none');
    }

    if(discountPriceElm.length) {
      discountPriceElm.text("(" + calculatDiscount(discountPriceElm.data('discount-value'), newPrice) + ")");
    }
    
    $('#' + formId + ' .product-item__add-to-cart button').html("Add To Cart <span title='"+ colorText +"'>("+ colorText +")</span>");
    if (imageSrc && imageSrc !== "undefined") {
      $('.product-' + productId + '_' + productIndex).find("img").attr("src",imageSrc);
    }
  });
  
  $('#pwp_products_container').on('click', '.copy-to-clipboard', function (e) {
    var element = $(this);
    var copyText = element.children('input[name="discount-code"]');
    var discountCode = element.children('span').text();
    
    copyText.show();
    /* Select the text field */
    copyText.select();
    element.css("color", "#1f2024");
    document.execCommand("copy");
    copyText.hide();
    element.children('span').text('Copied');

    setTimeout(function() {
      element.css("color", '#2f353d');
      element.children('span').text(discountCode);
    }, 800)
  });

}(jQuery));
